export const VALID_PROMOTIONS = ['oneforone', '1+1', 'freebie', 'bundle']

export enum PROMOTION_TYPES {
  ONE_FOR_ONE = 'oneforone',
  ONE_PLUS_ONE = '1+1',
  BUNDLE = 'bundle',
  FREEBIE = 'freebie',
  OUT_OF_TRADE = 'outOfTrade',
}
